export default String.raw`
<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{ translations.Offers }}
	</div>
	<div class="offers-js container-js" data-template="partials/customer-profile/offers/offers.html">
		{% include 'partials/customer-profile/offers/offers-list.html' -%}
	</div>
</div>
`